import React from 'react';
import { useSiteData, DataContextProps } from '@context';
import { Link } from '@base-components';
import { ContactFormButton } from '@components';

/**
 * Footer Navigation.
 */
const FooterNavigation = (): JSX.Element | null => {
  const { siteData }: DataContextProps = useSiteData();
  if (siteData) {
    const { translations, currentLocale } = siteData;
    const localeLinkPrefix = currentLocale !== 'en' ? `${currentLocale}/` : '';

    /**
     * Render.
     */
    return (
      <div className="footer-navigation">
        <ul>
          <li>
            <Link url={`/${currentLocale}/resources/faqs`}>
              {translations?.faqs}
            </Link>
          </li>
          <li>
            <Link url={`/${currentLocale}/resources/glossary`}>
              {translations?.glossary}
            </Link>
          </li>

          <li>
            <Link
              url={`https://cancercare.siemens-healthineers.com/${localeLinkPrefix}about-us/legal-information/copyright-notice-and-trademarks`}
            >
              {translations?.trademarks}
            </Link>
          </li>
          <li>
            <ContactFormButton />
          </li>
          <li>
            <Link
              url={`https://cancercare.siemens-healthineers.com/${localeLinkPrefix}about-us/legal-information/privacy-notice`}
            >
              {translations?.privacy_notice}
            </Link>
          </li>
        </ul>
      </div>
    );
  }
  return null;
};
export default FooterNavigation;
